import React, { useState, useEffect } from "react"
import { Button, Autocomplete, TextField, ListSubheader, Skeleton } from '@mui/material'
import VirtualListbox from '../ui/VirtualListbox'
import useTickers from '../../hooks/useTickers'
import styles from './CompetitionHeader.module.scss'
import axios from "axios"

export default function CompetitionHeader({ clickUpdateButton, tickersList, ticker }) {
    const [tickers, setTickers] = useState([])
    const [selectedValues, setSelectedValues] = useState([])
    const [error, setError] = useState(false)
    // const { tickers } = useTickers()


    const GetTickers = async () => {
        // const resJson = await fetch(`/api/getCompetitorTickers?ticker=${ticker}`)
        const resJson = await axios.get(`/api/getCompetitorTickers?ticker=${ticker}`)
        const res = await resJson.data
        setTickers(res)
    }

    useEffect(() => {
        GetTickers()
        return () => {}
    }, [])
    

    useEffect(() => {
        if (tickers && tickers.length > 0) {
            const selected = tickers.filter(at =>  tickersList.includes(at.value))
            setSelectedValues(selected)
        }
        return () => {}
    }, [tickers, tickersList])
    
    const handleChange = (_, newValue) => {
        if (newValue.length <= 3) {
            setSelectedValues(newValue)
            setError(false)
        } else {
            setError(true)
        }
    }

    const search = (e) => {
        e.preventDefault()
        setError(false)
        const selectedTickers = selectedValues.map(ticker => ticker.value)
        clickUpdateButton(selectedTickers)
    }

    const renderOption = (params, option) => (
        <li {...params}>
            <div className={styles['option']}>
                <div>{option.value}</div>
                <div>{option.name}</div>
            </div>
        </li>
    )

    const renderInput = (params) => (
        <TextField
            {...params}
            placeholder="Choose up to 3 companies"
            InputProps={{...params.InputProps, classes:{notchedOutline: styles['text-field-input']}}}
            error={error}
        />
    )

    const renderGroup = (params) => ([
        <ListSubheader key={params.key} component="div">{params.group}</ListSubheader>,
        params.children,
    ])
    
    return (
        <div className={styles.header}>
            {tickers.length?
            <form className={styles.selectForm} onSubmit={search}>
                <Autocomplete
                    multiple
                    disableListWrap
                    options={tickers}
                    getOptionLabel={(option) => `${option.value} - ${option.name}`}
                    groupBy={(option) => option.category}
                    value={selectedValues}
                    onChange={handleChange}
                    renderInput={renderInput}
                    renderOption={renderOption}
                    renderGroup={renderGroup}
                    ListboxComponent={VirtualListbox}
                    className={styles.selector}
                    getOptionDisabled={(option) => option.value === ticker}
                />
                <Button type="submit" variant="contained" color="primary">
                    Update
                </Button>
            </form>:<Skeleton />}
            <div>
            </div>
        </div>
    )
}